var map = {
	"./american-express.png": "./src/aplicacao/_assets/imagens/cartoes/american-express.png",
	"./diners-club.png": "./src/aplicacao/_assets/imagens/cartoes/diners-club.png",
	"./elo.png": "./src/aplicacao/_assets/imagens/cartoes/elo.png",
	"./hipercard.png": "./src/aplicacao/_assets/imagens/cartoes/hipercard.png",
	"./mastercard-maestro.png": "./src/aplicacao/_assets/imagens/cartoes/mastercard-maestro.png",
	"./mastercard.png": "./src/aplicacao/_assets/imagens/cartoes/mastercard.png",
	"./rede-shop.png": "./src/aplicacao/_assets/imagens/cartoes/rede-shop.png",
	"./sodexo.png": "./src/aplicacao/_assets/imagens/cartoes/sodexo.png",
	"./sorocred.png": "./src/aplicacao/_assets/imagens/cartoes/sorocred.png",
	"./ticket-alimentacao.png": "./src/aplicacao/_assets/imagens/cartoes/ticket-alimentacao.png",
	"./ticket-restaurante.png": "./src/aplicacao/_assets/imagens/cartoes/ticket-restaurante.png",
	"./visa-electron.png": "./src/aplicacao/_assets/imagens/cartoes/visa-electron.png",
	"./visa-vale.png": "./src/aplicacao/_assets/imagens/cartoes/visa-vale.png",
	"./visa.png": "./src/aplicacao/_assets/imagens/cartoes/visa.png",
	"./vr.png": "./src/aplicacao/_assets/imagens/cartoes/vr.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/aplicacao/_assets/imagens/cartoes sync recursive ^\\.\\/.*$";